// Reusable page header for sub-pages
export default function PageHero({ eyebrow, title, italic, subtitle, image }) {
  return (
    <section
      data-testid="page-hero"
      data-on-dark
      className="relative pt-32 md:pt-44 pb-16 md:pb-24 overflow-hidden bg-ink text-white"
    >
      {image && (
        <div
          className="absolute inset-0 opacity-30 kenburns"
          style={{
            backgroundImage: `url(${image})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
      )}
      <div className="absolute inset-0 bg-gradient-to-b from-ink/70 via-ink/85 to-ink" />
      <div className="relative max-w-[1400px] mx-auto px-5 md:px-8">
        {eyebrow && (
          <div className="font-mono text-[11px] tracking-[0.25em] uppercase text-white/60 mb-5">
            {eyebrow}
          </div>
        )}
        <h1 className="font-display text-4xl sm:text-5xl lg:text-7xl leading-[1.02] tracking-[-0.03em] max-w-4xl">
          {title}
          {italic && (
            <>
              <br />
              <span className="font-serif-italic font-normal text-white/80">
                {italic}
              </span>
            </>
          )}
        </h1>
        {subtitle && (
          <p className="mt-6 text-base md:text-lg text-white/70 max-w-2xl leading-relaxed">
            {subtitle}
          </p>
        )}
      </div>
    </section>
  );
}
